import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Breadcrumbs, Stack, Tab, Typography } from '@mui/material';
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import ListView from './ListView';
import {
  onChangeFilter,
  onGetApprovalSK,
  onGetCompletedDigisign,
  onGetCompletedDigisignSk,
  onGetComposerDigisign,
  onGetDocumentCounter,
  onGetDraftDigisign,
  onGetMonitoringListDigisign,
  onGetNeedSignSK,
  onGetRejectedDigisignSk,
  onGetRevisiDigisignSk,
  onGetSignedDigisign,
  onResetDigisign,
} from 'redux/actions/DigitalSign';
import { useSelector } from 'react-redux';
import { blue, green, red, yellow } from '@mui/material/colors';
import { CardCounter } from 'shared/components/Cards';
import { TabContext, TabList } from '@mui/lab';
import { COLORS } from 'shared/constants/AppEnums';
import AppInfoView from '@crema/core/AppInfoView';

const DokumenSk = () => {
  const { id } = useParams();
  const { type } = useParams();
  const dispatch = useDispatch();
  const navigation = useNavigate();
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();

  const { profileMe } = useSelector((state) => state.profile);
  const { filter, dashboardSk } = useSelector((state) => state.digiSign);

  const [tabLength, setTabLength] = useState(1);
  const [refresh, setRefresh] = useState(false);
  const [ppidRole, setPpidRole] = useState(false);
  const [tabValue, setTabValue] = useState('sdmao');
  const [dirjendRole, setDirjendRole] = useState(false);
  const [monitoringRole, setMonitoringRole] = useState(false);

  const renderBreadcrumb = () => {
    return (
      <Breadcrumbs aria-label='breadcrumb'>
        <Typography
          sx={{
            cursor: 'pointer',
            fontWeight: pathname === '/apps/dokumen-sk' ? 'bold' : '500',
          }}
          color={'primary.default'}
          variant='h3'
          onClick={() => {
            navigation(`/apps/dokumen-sk`);
          }}
        >
          Dokumen Sk
        </Typography>

        {pathname === `/apps/dokumen-sk/tambah-dokumen/${type}` ? (
          <Typography
            color={'primary.default'}
            sx={{ cursor: 'pointer' }}
            variant='h3'
            fontWeight={'bold'}
          >
            Tambah
          </Typography>
        ) : pathname === `/apps/dokumen-sk/tambah-dokumen/${type}/${id}` &&
          id !== undefined ? (
          <Typography
            color={'primary.default'}
            sx={{ cursor: 'pointer' }}
            variant='h3'
            fontWeight={'bold'}
          >
            Ubah Draft
          </Typography>
        ) : pathname === '/apps/dokumen-sk/tanda-tangan' ? (
          <Typography
            color={'primary.default'}
            sx={{ cursor: 'pointer' }}
            variant='h3'
            fontWeight={'bold'}
          >
            Tanda Tangan
          </Typography>
        ) : id !== undefined && pathname === `/apps/dokumen-sk/detail/${type}/${id}` ? (
          <Typography
            color={'primary.default'}
            sx={{ cursor: 'pointer' }}
            variant='h3'
            fontWeight={'bold'}
          >
            Detail
          </Typography>
        ) : null}
      </Breadcrumbs>
    );
  };

  const handleChangeTabValue = (event, newValue) => {
    // const url = newValue === 'pkrl' ? '/apps/perizinan-menteri/pkrl' : newValue === 'dashboard_pkrl' ? '/apps/perizinan-menteri/pkrl/dashboard' : '/apps/perizinan-menteri'
    navigation('/apps/dokumen-sk?type=' + newValue)
    setTabValue(newValue);
  };

  const handleCardClick = (state) => {
    dispatch(onChangeFilter(state));
  };

  const setDocumentType = (input) => {
    switch (input) {
      case 'sdmao':
        return 'dokumen_sk';
      case 'ppid':
        return 'dokumen_ppid';
      case 'dirjend':
        return 'dokumen_dirjend';
      default:
        return 'dokumen_sk';
    }
  };

  useEffect(() => {
    if (profileMe) {
      let tmpTab = 1;
      const monitoringRole =
        profileMe.roles_coofis.findIndex(
          (x) => x.state === 'MONITORING_DIGITAL_SIGN',
        ) > -1
          ? true
          : false;

      const ppidRole =
        profileMe.roles_coofis.findIndex((x) => x.state === 'SK.PPID') > -1
          ? true
          : false;
      const dirjendRole =
        profileMe.roles_coofis.findIndex(
          (x) => x.state === 'SK.DIRJEND',
        ) > -1
          ? true
          : false;

      if ((!ppidRole && !dirjendRole) && !monitoringRole) tmpTab = 1;
      else tmpTab = 2

      setTabLength(tmpTab);
      setPpidRole(ppidRole);
      setDirjendRole(dirjendRole);
      setMonitoringRole(monitoringRole);
    }
  }, [profileMe]);

  useEffect(() => {
    if (pathname === '/apps/dokumen-sk') {
      if (filter === 'composer') {
        dispatch(onGetComposerDigisign(setDocumentType(tabValue)));
      } else if (filter === 'sk-need-approval') {
        dispatch(onGetApprovalSK(setDocumentType(tabValue)));
      } else if (filter === 'sk-need-sign') {
        dispatch(onGetNeedSignSK(setDocumentType(tabValue)));
      } else if (filter === 'sk-completed') {
        dispatch(onGetCompletedDigisignSk(setDocumentType(tabValue), '', 0, 10));
      } else if (filter === 'draft') {
        dispatch(onGetDraftDigisign(setDocumentType(tabValue)));
      } else if (filter === 'completed') {
        dispatch(onGetCompletedDigisign(setDocumentType(tabValue), '', 0, 10));
      } else if (filter === 'rejected') {
        dispatch(onGetRejectedDigisignSk(setDocumentType(tabValue)));
      } else if (filter === 'signed') {
        dispatch(onGetSignedDigisign(setDocumentType(tabValue)));
      } else if (filter === 'revisi') {
        dispatch(onGetRevisiDigisignSk(setDocumentType(tabValue)));
      } else if (filter === 'monitoring' && monitoringRole) {
        dispatch(onGetMonitoringListDigisign(setDocumentType(tabValue), '', 0, 10));
      }
    }

    if (searchParams.get('type') !== null) {
      setTabValue(searchParams.get('type'))
    }
  }, [dispatch, pathname, filter, refresh, tabValue]);

  useEffect(() => {
    let temp = ''
    if (tabValue === 'sdmao') {
      temp = `dokumen_sk`
    } else {
      temp = `dokumen_${tabValue}`
    }
    dispatch(onGetDocumentCounter(temp));
  }, [tabValue])

  useEffect(() => {
    dispatch(onResetDigisign());
  }, []);

  return (
    <Stack spacing={2}>
      <AppInfoView />

      {renderBreadcrumb()}

      {tabLength > 1 &&
        <TabContext value={tabValue}>
          <TabList
            onChange={handleChangeTabValue}
            aria-label='lab API tabs example'
            TabIndicatorProps={{
              style: {
                backgroundColor: COLORS.primary,
                borderRadius: '16px',
              },
            }}
            sx={{
              backgroundColor: 'white',
              borderRadius: '16px',
              '& .MuiTabPanel-root': {
                padding: '0 !important',
              },
              '& .Mui-selected': {
                color: `${COLORS.primary} !important`,
                fontWeight: 'bold',
              },
              '& .MuiButtonBase-root.MuiTab-root': {
                borderRadius: '20px',
                fontSize: 16,
              },
              '& .MuiTabs-flexContainer': {
                gap: 2,
              },
            }}
          >
            <Tab label='Dokumen SK SDMAO' value='sdmao' />
            {(ppidRole || monitoringRole) && <Tab label='Dokumen SK PPID' value='ppid' />}
            {(dirjendRole || monitoringRole) && <Tab label='Dokumen SK DIRJEN' value='dirjend' />}
          </TabList>
        </TabContext>
      }


      {dashboardSk && (
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={2}
          alignItems={'center'}
        >
          <CardCounter
            title='Need Approval'
            description=''
            value={dashboardSk?.need_approval}
            color={yellow[500]}
            onClick={() => handleCardClick('sk-need-approval')}
            icon={'AssignmentLateOutlined'}
          />
          <CardCounter
            title='Need Sign'
            description=''
            onClick={() => handleCardClick('sk-need-sign')}
            value={dashboardSk?.need_sign}
            color={blue[500]}
            icon={'AssignmentLateOutlined'}
          />
          <CardCounter
            title='Revisi'
            description=''
            value={dashboardSk?.revisi}
            onClick={() => handleCardClick('revisi')}
            color={red[500]}
            icon={'AssignmentLateOutlined'}
          />
          <CardCounter
            title='Telah Selesai'
            value={dashboardSk?.done}
            onClick={() => handleCardClick('completed')}
            description=''
            color={green[500]}
            icon={'AssignmentTurnedInOutlined'}
          />
        </Stack>
      )}
      <ListView setRefresh={setRefresh} tipeDokumen={tabValue} />
    </Stack>
  );
};

export default DokumenSk;
